import { render, staticRenderFns } from "./ClassificationDegreeAdd.vue?vue&type=template&id=0f21ad72&"
import script from "./ClassificationDegreeAdd.vue?vue&type=script&lang=js&"
export * from "./ClassificationDegreeAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports